<template>
	<div class="box">
        <img src="@/assets/book_marketing_bg.jpg" class="bg"/>
        <div class="bottom">
            <img src="@/assets/guanli_btn.png"  class="button" @click="confrimClick('guanli')">
            <img src="@/assets/anzhuang_btn.png"  class="button" @click="confrimClick('anzhuang')">
            <img src="@/assets/tujian_btn.png"  class="button" @click="confrimClick('tujian')">
        </div>
	</div>
</template>

<script>
//土建营销活动
export default {
    data(){
        return {
        }
    },
	created(){
	},
    methods:{
        confrimClick(type){
            let id = ''
            //管理
            if(type== 'guanli'){
                id = '73062e3e2e334ca58c14a71aeafaf058'
            }else if(type == 'tujian'){//土建
                id = 'fa9e95d202c4464cbc5865bea03b4bc9'
            }else if(type == 'anzhuang'){//安装
                id = '5738c50f72414ff9b0f2e0cc215f7031'
            }
            window.location.href = window.location.origin + `/zj-wx-web-mp/pagesImp/learn/public/detail/detail?id=${id}&bookMarketing=3`
        }
    }

}
</script>

<style lang="stylus" scoped>
.box{
    min-height: 100vh;
    position: relative
    .bg{
        width: 100%;
        min-height: 100vh;
        height: 21.84rem;
        vertical-align: bottom;
    }
    .bottom{
        position: absolute;
        display: flex;
        flex-direction: column
        justify-content: center;
        align-items: center
        bottom: 0;
        width 100%;
        z-index 9;
        .button{
            width:7.73rem;
            height:0.8rem;
            margin-bottom:0.4rem;
            &:not(:last-child){
                margin-bottom:0.267rem;
            }

        }

    }
}

</style>
